import { render, staticRenderFns } from "./SearchMenu.vue?vue&type=template&id=06591e4c&scoped=true"
import script from "./SearchMenu.vue?vue&type=script&lang=js"
export * from "./SearchMenu.vue?vue&type=script&lang=js"
import style0 from "./SearchMenu.vue?vue&type=style&index=0&id=06591e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06591e4c",
  null
  
)

export default component.exports